import type {IconProps} from '@primer/octicons-react'
import {ActionList, Button} from '@primer/react'
import type {FunctionComponent, PropsWithChildren} from 'react'

import styles from './SharedEmptyPicker.module.css'

export type EmptyPickerProps = {
  leadingIcon?: FunctionComponent<PropsWithChildren<IconProps>>
  hotKey?: string
  label: string
  anchorProps?: React.HTMLAttributes<HTMLElement>
  readonly?: boolean
  ariaLabelledBy?: string
  /**
   * Whether to render the empty picker as a nested menu item (true) versus a standalone button (false; default).
   */
  nested?: boolean
}

export const SharedEmptyPicker = ({
  leadingIcon: LeadingIcon,
  hotKey,
  label,
  anchorProps,
  readonly,
  nested,
  ariaLabelledBy,
}: EmptyPickerProps) => {
  const sharedProps = {'aria-disabled': readonly, disabled: readonly, 'aria-labelledby': ariaLabelledBy}

  if (nested) {
    return (
      <ActionList.Item {...anchorProps} {...sharedProps} role="menuitem">
        {LeadingIcon && (
          <ActionList.LeadingVisual>
            <LeadingIcon />
          </ActionList.LeadingVisual>
        )}
        {label}
      </ActionList.Item>
    )
  }

  return (
    <Button
      size={'small'}
      leadingVisual={LeadingIcon}
      trailingVisual={hotKey ? () => <div className={styles.hotkeyBadge}>{hotKey}</div> : undefined}
      className={styles.dashedButton}
      {...sharedProps}
      {...anchorProps}
    >
      {label}
    </Button>
  )
}

try{ SharedEmptyPicker.displayName ||= 'SharedEmptyPicker' } catch {}